<template>
    <div
        class="modal fade"
        id="newFirmModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabindex="-1"
        aria-labelledby="staticBackdropLabel"
        aria-hidden="true"
    >
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="staticBackdropLabel">Přidání nové firmy</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <form @submit.prevent="addFirm">
                        <div class="form-floating mb-3">
                            <input type="text" class="form-control" id="floatingInput" placeholder="Jméno firmy" v-model="firmName" />
                            <label for="floatingInput">Jméno firmy</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckDefault" v-model="trackAccessCheckBox" />
                            <label class="form-check-label" for="flexCheckDefault"> Trackování </label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" value="" id="flexCheckChecked" v-model="galleryAccessCheckBox" />
                            <label class="form-check-label" for="flexCheckChecked"> Galerie </label>
                        </div>
                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Zavřít</button>
                    <button type="button" class="btn btn-primary" data-bs-dismiss="modal" @click="AddFirm">Uložit</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from "axios";

export default {
    name: "NewFirmModal",
    data() {
        return {
            firmName: "",
            galleryAccessCheckBox: false,
            trackAccessCheckBox: false,
        };
    },
    methods: {
        async AddFirm() {
            const headers = {
                Authorization: "Bearer " + localStorage.getItem("token"),
            };
            axios
                .post(
                    "http://admin.contactweb.cz/api/firms/register?firmName=" +
                        this.firmName +
                        "&accessGallery=" +
                        this.galleryAccessCheckBox +
                        "&accessTrack=" +
                        this.trackAccessCheckBox,
                    {},
                    {
                        headers: headers,
                    }
                )
                .then((response) => {
                    if (response.status == 200) {
                        axios
                            .get("http://admin.contactweb.cz/api/firms", {
                                headers: {
                                    Authorization: "Bearer " + localStorage.getItem("token"),
                                },
                            })
                            .then((response1) => {
                                this.$emit("refresh", response1.data);
                                this.firms = response1.data;
                                this.$moshaToast("Firma vytvořena.", { type: "success" });
                            });
                    }
                })
                .catch((error) => {
                    console.log(error);
                    this.$moshaToast(error.response.data, { type: "danger" });
                });
        },
    },
};
</script>
